import React from 'react';

export default function Tabs({ tabs = [], active, onChange }) {
  return (
    <div className="flex items-center gap-4 border-b pb-3">
      {tabs.map(tab => (
        <button key={tab.key} onClick={() => onChange(tab.key)} className={`text-sm pb-2 ${active===tab.key? 'text-purple-600 border-b-2 border-purple-600' : 'text-gray-500'}`}>
          {tab.label}
        </button>
      ))}
    </div>
  );
}
